module.exports = __webpack_public_path__ + "img/case.780aa65a.svg";